<template>
  <div class="my_form">
    <el-form :model="form" ref="ruleForm" inline>
      <el-row>
        <el-col :lg="8" :md="24">
          <el-form-item label="工单状态:" prop="workOrderStatus">
            <el-select clearable v-model="form.workOrderStatus" placeholder="工单状态">
              <el-option
                v-for="item in flowStatusOptions"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="24">
          <el-form-item label="项目名称:" prop="projectName">
            <el-select filterable clearable v-model="form.projectName" placeholder="请选择项目名称">
              <el-option
                v-for="item in projectNameOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="24">
          <el-form-item label="合同编号:" prop="contractNo">
            <el-input v-model="form.contractNo" placeholder="合同编号" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="8" :md="24">
          <el-form-item label="供货方名称:" prop="supplierName">
            <el-select filterable clearable v-model="form.supplierName" placeholder="请选择供货方">
              <el-option
                v-for="item in supplierNameOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="24">
          <el-form-item label="盖章状态:" prop="seal">
            <el-select clearable v-model="form.seal" placeholder="盖章状态">
              <el-option label="是" :value="true" />
              <el-option label="否" :value="false" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="24">
          <el-form-item label="合同类别:" prop="contractType">
            <el-select filterable clearable v-model="form.contractType" placeholder="请选择合同类别">
              <el-option
                v-for="item in contractTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="8" :md="24">
          <el-form-item label="新旧合同:" prop="oldContract">
            <el-select clearable v-model="form.oldContract" placeholder="请选择新旧合同">
              <el-option label="旧" :value="true" />
              <el-option label="新" :value="false" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="24" class="action" style="margin-bottom:20px">
          <el-button size="small" type="primary" @click="submitForm" plain>查询</el-button>
          <el-button size="small" @click="resetForm">重置</el-button>
          <el-button size="small" type="primary" @click="handleAdd">新增</el-button>
        </el-col>
      </el-row>
    </el-form>
    <STable :columns="columns" :loadData="loadData" ref="table">
      <template #sn='{ $index }'>
        {{ $index + 1 }}
      </template>
      <template #applyStatus="{ row }">
        {{ row.applyStatus == 3 ? '已办结' : '处理中' }}
      </template>
      <template #seal="{ row }">
        {{ row.seal == null ? '' : row.seal ? '是' : '否' }}
      </template>
      <template #action="record">
        <a href="javascript:;" @click="handleRecord(record.row)">操作记录</a>
        <a class="success" href="javascript:;" @click="handleEdit(record.row)">编辑</a>
      </template>
    </STable>
    <ContractFormDialog :visible.sync="dialogVisible" :rowData="editRow" @success="handleSuccess" />
    <el-dialog :title="recordTitle" :visible.sync="recordVisible" width="900px" top="6vh" @closed="onRecordClosed">
      <el-table :data="recordList" v-loading="recordLoading" border size="small" header-cell-class-name="table-header-gray" empty-text="暂无数据">
        <el-table-column label="序号" type="index" width="60px" align="center" />
        <el-table-column label="修改字段" prop="fieldLabel" width="160px" show-overflow-tooltip />
        <el-table-column label="原值" min-width="180px" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.oldValue == null || scope.row.oldValue === '' ? '-' : scope.row.oldValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label="新值" min-width="180px" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.newValue == null || scope.row.newValue === '' ? '-' : scope.row.newValue }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="operatorName" width="120px" show-overflow-tooltip />
        <el-table-column label="操作时间" prop="createTime" width="170px" show-overflow-tooltip />
      </el-table>
      <el-row type="flex" justify="end" style="margin-top: 10px;">
        <el-pagination
          :total="recordTotal"
          :current-page="recordPage.pageNum"
          :page-size="recordPage.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, prev, pager, next, sizes"
          @current-change="onRecordPageChange"
          @size-change="onRecordSizeChange">
        </el-pagination>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { Contract } from '@/api/contract'
import { OnlineOperation } from '@/api/onlineController.js'
import '@/staticDict/flowStaticDict.js';
import STable from '@/components/STable';
import ContractFormDialog from './modules/ContractFormDialog';
export default {
  components: {
    STable,
    ContractFormDialog
  },
  data () {
    return {
      form: {
        workOrderStatus: '',
        projectName: '',
        contractNo: '',
        supplierName: '',
        seal: undefined,
        contractType: '',
        oldContract: undefined
      },
      flowStatusOptions: [],
      projectNameOptions: [],
      supplierNameOptions: [],
      contractTypeOptions: [],
      dialogVisible: false,
      editRow: null,
      // 操作记录弹窗
      recordVisible: false,
      recordTitle: '操作记录',
      recordLoading: false,
      recordList: [],
      recordTotal: 0,
      recordContractId: null,
      recordPage: {
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          label: '序号',
          scopedSlots: 'sn',
          width: 80
        },
        {
          label: '项目名称',
          prop: 'projectName',
          ellipsis: true,
          width: 200
        },
        {
          label: '合同名称',
          prop: 'contractName',
          ellipsis: true,
          width: 200
        },
        {
          label: '合同类别',
          prop: 'contractType',
          ellipsis: true,
          width: 120
        },
        {
          label: '材料名称',
          prop: 'materialName',
          ellipsis: true,
          width: 150
        },
        {
          label: '合同编号',
          prop: 'contractNo',
          ellipsis: true,
          width: 180
        },
        {
          label: '含税合同金额（元）',
          prop: 'contractAmount',
          ellipsis: true,
          width: 180
        },
        {
          label: '合同实际金额（元）',
          prop: 'finalSettlementAmount',
          ellipsis: true,
          width: 180
        },
        {
          label: '供货方名称',
          prop: 'supplierName',
          ellipsis: true,
          width: 300
        },
        {
          label: '合同是否盖章',
          scopedSlots: 'seal',
          width: 120
        },
        {
          label: '终止状态',
          prop: 'finishStatus',
          ellipsis: true,
          width: 100
        },
        {
          label: '作废状态',
          prop: 'revokeStatus',
          ellipsis: true,
          width: 100
        },
        {
          label: '流程时间',
          prop: 'auditTime',
          ellipsis: true,
          width: 180
        },
        {
          label: '工单状态',
          scopedSlots: 'applyStatus',
          width: 100
        },
        {
          label: '操作',
          scopedSlots: 'action',
          width: 180,
          fixed: 'right'
        }
      ],
      loadData: (pageParam) => {
        const data = {
          ...this.form,
          ...pageParam
        }
        return Contract.getContractManageList(this, data).then(rs => rs)
      }
    }
  },
  created () {
    this.flowStatusOptions = this.SysFlowWorkOrderStatus.getList().filter(item => item.name === '处理中' || item.name === '已办结')
    this.loadProjectOptions()
    this.loadSupplierOptions()
    this.loadContractTypeOptions()
    const cache = localStorage.getItem('contractManageSearch')
    if (cache) {
      try {
        const params = JSON.parse(cache)
        Object.assign(this.form, params)
      } catch (e) {}
    }
  },
  methods: {
    handleAdd () {
      this.editRow = null
      this.dialogVisible = true
    },
    handleEdit (row) {
      this.editRow = row
      this.dialogVisible = true
    },
    // 打开操作记录弹窗并加载第一页
    handleRecord (row) {
      this.recordContractId = row.id
      this.recordTitle = row.contractName ? `操作记录（${row.contractName}）` : '操作记录'
      this.recordPage.pageNum = 1
      this.recordVisible = true
      this.loadRecordData()
    },
    loadRecordData () {
      this.recordLoading = true
      Contract.listFieldChangeRecord(this, {
        contractId: this.recordContractId,
        pageNum: this.recordPage.pageNum,
        pageSize: this.recordPage.pageSize
      }).then(rs => {
        this.recordList = (rs.data && rs.data.dataList) || []
        this.recordTotal = (rs.data && rs.data.totalCount) || 0
      }).catch(e => {
        this.recordList = []
        this.recordTotal = 0
      }).finally(() => {
        this.recordLoading = false
      })
    },
    onRecordPageChange (pageNum) {
      this.recordPage.pageNum = pageNum
      this.loadRecordData()
    },
    onRecordSizeChange (pageSize) {
      this.recordPage.pageSize = pageSize
      this.recordPage.pageNum = 1
      this.loadRecordData()
    },
    onRecordClosed () {
      this.recordList = []
      this.recordTotal = 0
      this.recordPage.pageNum = 1
      this.recordContractId = null
    },
    handleSuccess () {
      this.submitForm(false)
    },
    submitForm (flag = true) {
      localStorage.setItem('contractManageSearch', JSON.stringify(this.form))
      if (this.$refs.table) this.$refs.table.refresh(flag)
    },
    loadProjectOptions () {
      OnlineOperation.listDict(this, {
        dictId: '1637650160030846976'
      }).then(res => {
        this.projectNameOptions = res.data.map(item => ({
          label: item.name,
          value: item.name
        }))
      })
    },
    loadSupplierOptions () {
      Contract.getSupplierListAll(this, {
        oaFormContractDto: {}
      }).then(res => {
        const dataList = res.data || []
        this.supplierNameOptions = dataList.map(item => ({
          label: item,
          value: item
        }))
      })
    },
    loadContractTypeOptions () {
      this.contractTypeOptions = ['OA', '材料采购合同', '机械租赁合同', '专业分包合同', '劳务分包合同', '其余各类合同'].map(item => ({
        label: item,
        value: item
      }))
    },
    resetForm () {
      this.form = {
        workOrderStatus: '',
        projectName: '',
        contractNo: '',
        supplierName: '',
        seal: undefined,
        contractType: '',
        oldContract: undefined
      }
      this.$refs.table.refresh(true)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/element-variables.scss';
  .title {
    border: 1px solid #EDEDED;
    border-left-width: 5px;
    border-left-color: $--color-primary;
    margin-bottom: 20px;
  }

  .title p {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    margin: 0px;
    padding-left: 20px;
  }

  .title p span {
    font-size: 20px;
    color: $--color-primary;
  }

  .item-list {
    margin: 0px;
  }
  .item-list li {
    margin: 10px 0px;
  }

  .item {
    height: 48px;
    display: flex;
    align-items: center;
  }
  ::v-deep .el-form-item__content{
    margin-left: 0 !important;
  }
</style>
